export default "__VITE_ASSET__78bba3a2__"